import type { DsdEditorValueMatch } from "@/apis/dsd-editor/route";
import type { PlainDsdNoteReferenceStatus } from "@/types/plain-dsd-table";
import type { DsdEditorReviewMode } from "./rail/rail-counts";

type StatusByCellId = ReadonlyMap<string, PlainDsdNoteReferenceStatus>;

/** 주석·주석매칭에는 본문 셀 상태(주기 판정)가 없다 — 본문 셀을 칠하지도, 클릭을 받지도 않게 하는 빈 맵 */
const NO_CELL_STATUS: StatusByCellId = new Map();

/**
 * 모드가 문서 강조·셀 선택에 쓰는 입력 — 모드별 정책은 여기 한 곳이다.
 * 패널·근거 창은 그리는 것 자체가 달라 조립(dsd-review-document)에서 분기한다.
 */
export const getMatchingModeInputs = ({
  mode,
  valueMatches,
  noteValueMatches,
  backendStatusByCellId,
  derivedStatusByCellId,
}: {
  mode: DsdEditorReviewMode;
  valueMatches: DsdEditorValueMatch[];
  noteValueMatches: DsdEditorValueMatch[];
  /** 셀 선택 판정용 — 백엔드 상태가 있는 셀은 클릭을 받는다 */
  backendStatusByCellId: StatusByCellId;
  /** 셀 색 — 후보 카드·저장된 판단으로 파생한 상태(cell-verdict.ts) */
  derivedStatusByCellId: StatusByCellId;
}) => {
  const noteNote = mode === "note-note-matching";
  return {
    /** 선택·후보 강조·목차 배지·근거 창이 도는 매칭 목록 */
    matches: noteNote ? noteValueMatches : valueMatches,
    selectableStatusByCellId: noteNote ? NO_CELL_STATUS : backendStatusByCellId,
    colorStatusByCellId: noteNote ? NO_CELL_STATUS : derivedStatusByCellId,
    /** 문단 속 값을 세그먼트로 그리는가 — 두 매칭 모드에서만 (다른 모드는 평문) */
    showsParagraphValues: noteNote || mode === "note-reference-review",
  };
};
